import $ from 'jquery'
import Swiper from 'swiper';

class ComitiumGalleryManager {
    constructor(options) {
        this.options = {
            verticalGallerySelector: "[data-comitium-gallery-vertical]",
            horizontalGallerySelector: "[data-comitium-gallery-horizontal]",
            observerOptions: {
                root: null,
                rootMargin: "0px",
                threshold: [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0]
            },
            dispatchDisplayImageOnce: true,
            swiperOptions: {
                loop: true,
                speed: 800,
                slidesPerView: 1,
                spaceBetween: 25,
                centeredSlides: true,
                effect: 'coverflow',
                coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 0,
                    modifier: 1,
                    slideShadows: true,
                },
                grabCursor: true,
                parallax: true,
            }
        };

        this.images = [];

        Object.assign(this.options, options);

        this.init();
    }
    init() {
        var observers = [],
            _this = this;

        function observerCallBack(entries) {
            entries.forEach(function (entry) {
                if (Math.floor(entry.intersectionRatio * 100) > 50) {
                    var $element = $(entry.target);

                    _this.dispatchDisplayImageEvent($element, "vertical");

                    observers[$element.data("image-id")].disconnect();
                }
            });
        }

        $(this.options.verticalGallerySelector).each(function () {

            $(this).find("[data-image-id]").each(function () {
                var imageId = $(this).data("image-id");

                observers[imageId] = new IntersectionObserver(observerCallBack, _this.options.observerOptions);
                observers[imageId].observe(document.querySelector("[data-image-id='" + imageId + "']"));
            });
        });

        $(this.options.horizontalGallerySelector).each(function () {
            var $elem = $(this),
                swiperOptions = {
                    navigation: {
                        nextEl: $elem.find('.swiper-button-next'),
                        prevEl: $elem.find('.swiper-button-prev'),
                    },
                    on: {
                        slideChangeTransitionEnd: function () {
                            _this.dispatchDisplayImageEvent($(this.$el).find(".swiper-slide-active [data-image-id]"), "horizontal");
                        }
                    },
                };

            Object.assign(swiperOptions, _this.options.swiperOptions);

            new Swiper($elem, swiperOptions);
        });
    }
    dispatchDisplayImageEvent($element, galleryType) {
        if (this.hasToDispatch($element) === false) {
            return;
        }
        this.images.push($element.data("image-id"));

        document.dispatchEvent(new CustomEvent('comitium.gallery.image.displayed', {
            detail: {
                element: $element,
                galleryType: galleryType
            }
        }));
    }
    hasToDispatch($element) {
        if (this.options.dispatchDisplayImageOnce === false) {
            return true;
        }

        return this.images.includes($element.data("image-id")) === false;
    }
}

export default ComitiumGalleryManager;